// product list
export const CATEGORY_POST_REQUEST = 'CATEGORY_POST_REQUEST';
export const CATEGORY_POST_SUCCESS = 'CATEGORY_POST_SUCCESS';
export const CATEGORY_POST_ERROR = 'CATEGORY_POST_ERROR'; 

export const GET_ALL_CATEGORY_MERCHANT_REQUEST = 'GET_ALL_CATEGORY_MERCHANT_REQUEST';
export const GET_ALL_CATEGORY_MERCHANT_SUCCESS = 'GET_ALL_CATEGORY_MERCHANT_SUCCESS';
export const GET_ALL_CATEGORY_MERCHANT_ERROR = 'GET_ALL_CATEGORY_MERCHANT_ERROR'; 